export const gradeList = ['K1', 'K2', 'K3', 'P1', 'P2', 'P3', 'P4', 'P5', 'P6'];
export const excludeMenuList = ['requirement', 'student-requirement', 'online-course', 'video', 'setting-requirement'];